/* ============================================================
   MYNA PATCHES v9
   - Saves myna_pre_login_url on every page load
   - Bounces back from /pages/kp-account to saved URL
   - Blocks SPA pushState/replaceState to /pages/kp-account
   - Kills GoKwik ctx[48] redirect using correct Svelte 4 $$ accessor
   ============================================================ */
(function preventGoKwikRedirect(){
  var path = window.location.pathname;

  /* Save current page as return URL — skip /account/* and /pages/kp-account */
  if(path !== '/pages/kp-account' && path.indexOf('/account') !== 0){
    try{ sessionStorage.setItem('myna_pre_login_url', window.location.href); }catch(_){}
  }

  /* Bounce back from kp-account to wherever the user came from */
  if(path === '/pages/kp-account'){
    try{
      var ret = sessionStorage.getItem('myna_pre_login_url');
      if(ret && ret.indexOf('/pages/kp-account') < 0 && ret.indexOf('/account') < 0){
        sessionStorage.removeItem('myna_pre_login_url');
        window.location.replace(ret);
        return;
      }
    }catch(_){}
    /* No valid return URL — stay on /pages/kp-account */
    return;
  }

  /* Block SPA pushState/replaceState to /pages/kp-account */
  if(!history._mynaKpBlocked){
    var oP = history.pushState.bind(history);
    var oR = history.replaceState.bind(history);
    history.pushState = function(s,t,u){
      if(u && String(u).indexOf('/pages/kp-account') >= 0) return;
      return oP(s,t,u);
    };
    history.replaceState = function(s,t,u){
      if(u && String(u).indexOf('/pages/kp-account') >= 0) return;
      return oR(s,t,u);
    };
    history._mynaKpBlocked = true;
  }

  /* Disable GoKwik Svelte ctx[48] — post-login redirect config.
     Supports both Svelte 3 (kp.$) and Svelte 4 (kp.$$) */
  function killCtx48(){
    try{
      var kp = window.kpMerchantScript;
      /* Try Svelte 4 first ($$.ctx), fall back to Svelte 3 ($.ctx) */
      var ctx = (kp && kp.$$ && kp.$$.ctx) || (kp && kp.$ && kp.$.ctx);
      if(ctx && ctx[48] && ctx[48].enabled){
        ctx[48] = {enabled: false, redirect_url: '', vendor: ''};
      }
    }catch(_){}
  }
  killCtx48();
  [200, 600, 1200, 2500, 5000].forEach(function(t){ setTimeout(killCtx48, t); });
})();
